import {
  NEW_NOTIFICATION_MESSAGE,
  OPEN_NOTIFICATION,
  CLOSE_NOTIFICATION,
  SET_NOTIFICATION_SEVERITY,
} from '../constants/action-types';

export interface IState {
  showNotification: boolean;
  newNotificationMessage: string;
  notificationSeverity: 'success' | 'error' | 'warning' | 'info';
}

const initialState: IState = {
  showNotification: false,
  newNotificationMessage: '',
  notificationSeverity: 'info',
};

const rootReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case OPEN_NOTIFICATION:
      return { ...state, showNotification: action.payload };
    case CLOSE_NOTIFICATION:
      return { ...state, showNotification: action.payload };
    case NEW_NOTIFICATION_MESSAGE:
      return { ...state, newNotificationMessage: action.payload };
    case SET_NOTIFICATION_SEVERITY:
      return { ...state, notificationSeverity: action.payload };

    default:
      return state;
  }
};

export default rootReducer;
